<template>
  <div class="text-center">
    <div
      class="containerClass"
      :style="containerStyle"
      v-if="image == 'all'"
    ></div>
    <div v-if="imageKeys.includes(image)" class="imgDiv">
      <img
        :src="imgRoot + images[image].src"
        :style="blurStyle"
        :alt="image + 'image'"
      />
      <div class="vaCaption" v-if="showVA">{{ chartVA }} <br /></div>
    </div>
    <!-- {{ prettyString(uncorrectedRx) }} -->
  </div>
</template>

<script>
// import Name from "../dir/file";
import RxMethods from "@/assets/js/cls/RxMethods";
import VsDefinitions from "./VsDefinitions";

export default {
  name: "BlurImage",
  mixins: [RxMethods],
  props: {
    size: {
      type: Number,
      default: 400,
    },
    uncorrectedRx: null,
    image: { type: String, default: "far" }, // intermediate, near, outside
    showVA: null,
  },
  data: function () {
    return {
      imgRoot: "https://www.eyedock.com/images/visionSimulator/",

      va: 15,
    };
  },
  methods: {},
  computed: {
    imageKeys: function () {
      return Object.keys(this.images);
    },
    containerStyle: function () {
      return {
        width: this.size + "px",
        height: this.size + "px",
      };
    },

    blurStyle: function () {
      let rtn = "";
      rtn += `max-width:${this.size}px; max-height:${this.size}px; `;
      if (this.va) {
        let blurPx = (this.va - 15) / (25 + this.va / 15); // formula from my arse
        if (blurPx < 0) blurPx = 0;
        rtn += `filter:blur(${blurPx}px)`;
      }
      return rtn;
      // return Math.abs(this.images[this.image].diopters - this.dioptricFocus);
    },
    chartVA: function () {
      return this.va ? this.eyeChartVA(this.va) : null;
    },
    images: function () {
      return VsDefinitions.lookingAtData;
    },
  },
  watch: {
    uncorrectedRx: {
      handler: function (val) {
        // console.log(val);
        this.va = this.VAFromCorrection2(val);
      },
      deep: true,
    },
  },
  mounted() {
    this.va = this.VAFromCorrection2(this.uncorrectedRx);
  },
};
</script>

<style scoped>
.containerClass {
  position: relative;
  background-color: #fff5e0;
  overflow: hidden;
  border: 1px solid #3e3e3e;
  border-radius: 1%;
}
.absClass {
  position: absolute;
}
.frame {
  width: 47%;
  left: 5%;
  top: 5%;
}
.far {
  width: 42%;
  left: 7%;
  top: 7%;
}
.intermediate {
  width: 66%;
  left: 32%;
  top: 30%;
}
.near {
  width: 40%;
  left: 5%;
  top: 52%;
}
.hoverHeight {
  height: 50%;
}
.on-hover {
  background-color: rgba(15, 142, 15, 0.374);
}
.imgDiv {
  position: relative;
}
.vaCaption {
  position: absolute;
  width: 80%;
  max-width: 74px;
  left: 50%;
  bottom: 3px;
  font-size: smaller;
  background-color: #00000069;
  color: #fff;
  font-weight: bold;
  transform: translate(-50%);
}
</style>
